module.exports = __webpack_public_path__ + "a4a8ccb6346ef307eedf95d969da65aa.svg";